<template>
  <b-card
  :header-bg-variant="hasError ? 'danger': null"
  :border-variant="hasError ? 'danger': null"
  body-class="py-0 px-1"
  header-class="py-1 px-2"
  footer-class="p-1"
  class="mb-0"
  :header="label">
    <h5 class="m-0">
      <b-badge v-for="tag in tags" :key="tag" variant="warning"
        class="my-1 font-weight-normal"
        :class="{'mr-1': $dir.ltr , 'ml-1': $dir.rtl}">
        {{tag}}
        <a href="#" class="text-white" @click.prevent="removeTag(tag)">
          <font-awesome-icon icon="times-circle" class="align-middle" />
        </a>
      </b-badge>
    </h5>
    <div slot="footer">
      <auto-complete
        dir="auto"
        size="sm"
        icon-y-pos="5px"
        icon-x-pos="37px"
        :select="select"
        :search="search"
        :text="addingTag"
        @textChanged="setAddingTag"
        @input="addTag">
        <b-btn variant="success" :disabled="!addingTag" @click="addTag">
          <font-awesome-icon icon="plus" />
        </b-btn>
      </auto-complete>
    </div>
  </b-card>
</template>

<script>
import AutoComplete from './AutoComplete'
import _ from 'lodash'

export default {
  name: 'tagEditor',
  components: {
    AutoComplete
  },
  props: {
    value: { type: String },
    label: { type: String },
    autoSave: { type: Boolean, default: true },
    hasError: { type: Boolean, default: false },
    select: Function, // Promise : gets value and returns {value,text} object
    search: Function // Promise : gets keyword and returns [{value,text}] array
  },
  data () {
    return {
      addingTag: null,
      val: this.value
    }
  },
  watch: {
    value (newVal, oldVal) {
      if (newVal !== oldVal) this.val = newVal
    },
    val (newVal, oldVal) {
      this.$emit('input', newVal)
    }
  },
  computed: {
    tags: {
      get: function () {
        return this.val ? this.val.split(' ') : []
      },
      set: function (v) {
        if (v && v.length) {
          this.val = _.uniq(v).join(' ')
        } else {
          this.val = null
        }
      }
    }
  },
  methods: {
    setAddingTag (val) {
      this.addingTag = val
    },
    addTag () {
      if (this.addingTag && !this.tags.find(t => t === this.addingTag)) {
        this.tags = this.tags.concat([this.addingTag])
        this.addingTag = null
      }
    },
    removeTag (tag) {
      this.tags = this.tags.filter(t => t !== tag)
    }
  }
}
</script>
